import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/job/${':jobId' | number}/syncDiff`;

export type * from './requestModel';
export type * from './viewModel';

export const ROUTE: RouteDefinition = `${baseRoute}/job/:jobId/syncDiff`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/job/${jobId}/syncDiff`;
